import { useState } from 'react';
import { useSelector } from 'react-redux';

import { dateFormat } from 'common/helpers/dateHelper';

import { isUpcomingHold, nextHold } from '../helpers';

// eslint-disable-next-line import/no-cycle
import DeleteHoldModal from './components/DeleteHoldModal';

const UpcomingHoldMessage = (props) => {
  const { clubMembership } = props;
  const settings = useSelector((state) => state.setting);
  const [modal, setModal] = useState(null);
  const [holdId, setHoldId] = useState(null);

  const handleDeleteHold = (e) => {
    e.preventDefault();
    const id = e.currentTarget.getAttribute('data-id');
    setHoldId(id);
    setModal('deleteHold');
  };

  const handleCloseModal = () => {
    setHoldId(null);
    setModal(null);
  };

  const isFuture = isUpcomingHold(clubMembership);
  if (!isFuture) {
    return null;
  }
  const uHold = nextHold(clubMembership);
  return (
    <>
      Your club will be on hold on {dateFormat(uHold.holdStartDate, settings)}.
      <br />
      <br />
      <a
        onClick={handleDeleteHold}
        data-id={uHold.holdId}
        className="c7-button-alt-small"
      >
        Remove Hold
      </a>
      <br />
      <Modal
        modal={modal}
        handleCloseModal={handleCloseModal}
        clubMembershipId={clubMembership.id}
        holdId={holdId}
      />
    </>
  );
};

const Modal = (props) => {
  const { modal, handleCloseModal, clubMembershipId, holdId } = props;
  switch (modal) {
    case 'deleteHold': {
      return (
        <DeleteHoldModal
          holdId={holdId}
          onCloseModal={handleCloseModal}
          clubMembershipId={clubMembershipId}
        />
      );
    }
    default: {
      return null;
    }
  }
};

export default UpcomingHoldMessage;
